const environment = [
  // 应用编码
  {
    name: 'APP_CODE',
    value: 'enas-ops'
  },
  // 环境未匹配时，默认端口配置
  {
    name: 'PORT_CONFIG',
    value: {
      api: 99, // AUTO/91 浏览器上下文环境端口/91端口
      img: 4195
    }
  },
  // 环境对应配置
  {
    name: 'ENV_CONFIG',
    value: [
      {
        hostname: ['localhost', '127.0.0.1'],
        url: {
          api: 'http://10.20.1.7',
          hmi: 'http://10.20.1.7',
          img: 'http://10.20.1.7',
        },
      },
      {
        hostname: ['192.168.2.22'],
        port: {
          api: 11088
        }
      }
    ]
  },
]

export default environment